import { Box, Typography } from "@mui/material";
import React from "react";

const CustomerDetails = ({ data }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "1rem",
        padding: "1rem",
        borderRadius: "0.5rem",
        border: "1px solid",
        borderColor: "grey.200",
        mt: "1rem",
      }}
    >
      <Typography variant="h4" component="span" className="font-extrabold">
        Customer Details
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          gap: "1rem",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
          }}
        >
          <Typography variant="h6" component="span" className="font-bold">
            Name
          </Typography>
          <Typography variant="h6" component="span" className="font-bold">
            Email
          </Typography>
          <Typography variant="h6" component="span" className="font-bold">
            Phone
          </Typography>
          <Typography variant="h6" component="span" className="font-bold">
            City
          </Typography>
          <Typography variant="h6" component="span" className="font-bold">
            Enquiry Status
          </Typography>
          <Typography variant="h6" component="span" className="font-bold">
            Budget
          </Typography>
          <Typography variant="h6" component="span" className="font-bold">
            Lead Status
          </Typography>
          <Typography variant="h6" component="span" className="font-bold">
            Next Follow Up
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem",
          }}
        >
          <Typography variant="h6" component="span">
            {data?.customerName || "N/A"}
          </Typography>
          <Typography variant="h6" component="span">
            {data?.customerEmail || "N/A"}
          </Typography>
          <Typography variant="h6" component="span">
            {data?.customerNumber || "N/A"}
          </Typography>
          <Typography variant="h6" component="span">
            {data?.customerCity || "N/A"}
          </Typography>
          <Typography variant="h6" component="span">
            {data?.enquiryStatus || "N/A"}
          </Typography>
          <Typography variant="h6" component="span">
            {data?.budget || "N/A"}
          </Typography>
          <Typography variant="h6" component="span">
            {data?.leadStatus || "N/A"}
          </Typography>
          <Typography
            variant="h6"
            component="span"
            sx={{
              color:
                new Date(data?.nextFollowUpDate) > new Date() ? "green" : "red",
            }}
          >
            {/* Date in Locale */}
            {new Date(data?.nextFollowUpDate).toLocaleDateString("en-IN", {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
            })}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default CustomerDetails;
